import { render, staticRenderFns } from "./Supporter.vue?vue&type=template&id=090decc6&"
import script from "./Supporter.vue?vue&type=script&lang=js&"
export * from "./Supporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports